module.exports = __webpack_public_path__ + "static/media/qr-code.e4db589e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/qr-code.png
// module id = 10422
// module chunks = 25